import { Tag } from 'antd';
import React from 'react';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getPaymentsG, getPaymentU } from '../../../services/calc/paymentCalc';
import { getWps } from '../../../services/calc/wpsCalc';
import { useTypedSelector } from '../../../store';
import { BLUE } from '../../../styles';
import ResultRow from '../SumUpHead/ResultRow';
import { WpsTitle } from './WpsTitle';

const Fee = () => {
  const {
    overallInterestsSum,
    compensationSum,
    finalSum,
  } = useTypedSelector(state =>
    state.sumUp, shallowEqual);
  const { t } = useTranslation();
  return (
    <>
      <WpsTitle title={t('fee.title')} />
      <ResultRow
        sum1={getPaymentsG(getWps(finalSum))}
        sum2={getPaymentsG(getWps(overallInterestsSum + finalSum))}
        sum3={getPaymentsG(getWps(finalSum + compensationSum + overallInterestsSum))}
        legal={t('fee.legal')}
      />

      <WpsTitle title={t('fee.title')} />
      <Tag color={BLUE}>{t('fee.badge')}</Tag>
      <ResultRow
        sum1={getPaymentU(getWps(finalSum))}
        sum2={getPaymentU(getWps(overallInterestsSum + finalSum))}
        sum3={getPaymentU(getWps(finalSum + compensationSum + overallInterestsSum))}
        legal={t('fee.legal2')}
      />
    </>
  );
};

export default Fee;